import {Tenant} from "../../model";
import {ApiBuilder} from "..";
import {TenantMenuItem, UpdateTenant} from "@core/model/Tenant";

const clearMeasures = (builder: ApiBuilder) =>
  builder.mutation<void, string>({
    query: tenantId => ({
      url: `/api/tenant/clear-measures/${tenantId}`,
      method: "DELETE",
    }),
  });

const clearDisk = (builder: ApiBuilder) =>
  builder.mutation<void, string>({
    query: tenantId => ({
      url: `/api/tenant/clear-disk/${tenantId}`,
      method: "DELETE",
    }),
  });

const fetchTenant = (builder: ApiBuilder) =>
  builder.query<Tenant, void>({
    query: () => ({
      url: "/api/public/tenant",
      method: "GET",
    }),
    providesTags: result => (result ? [{type: "tenant", id: "current"}] : []),
  });

const updateTenantMenu = (builder: ApiBuilder) =>
  builder.mutation<string, {tenantId: string; items: TenantMenuItem[]}>({
    query: ({tenantId, items}) => ({
      url: `/api/tenant/menu/${tenantId}`,
      method: "PUT",
      body: items,
    }),
  });

const updateTenantSettings = (builder: ApiBuilder) =>
  builder.mutation<string, UpdateTenant>({
    query: ({id, ...body}) => ({
      url: `/api/tenant/update/${id}`,
      method: "PUT",
      body,
    }),
  });

export {
  clearMeasures,
  clearDisk,
  fetchTenant,
  updateTenantMenu,
  updateTenantSettings,
};
